import { render, staticRenderFns } from "./facultyStrength.vue?vue&type=template&id=a8566a84&scoped=true"
import script from "./facultyStrength.vue?vue&type=script&lang=js"
export * from "./facultyStrength.vue?vue&type=script&lang=js"
import style0 from "./facultyStrength.vue?vue&type=style&index=0&id=a8566a84&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8566a84",
  null
  
)

export default component.exports